import { render, staticRenderFns } from "./SystemUserLayout.vue?vue&type=template&id=525e61ca&scoped=true"
import script from "./SystemUserLayout.vue?vue&type=script&lang=js"
export * from "./SystemUserLayout.vue?vue&type=script&lang=js"
import style0 from "./SystemUserLayout.vue?vue&type=style&index=0&id=525e61ca&prod&lang=scss&scoped=true"
import style1 from "./SystemUserLayout.vue?vue&type=style&index=1&id=525e61ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e61ca",
  null
  
)

export default component.exports